export default __webpack_public_path__ + "static/media/aboutme.ff497e3d.jpg";